<template>
  <div>
    <navigation></navigation>
    <div class="container mx-auto px-4 mb-10">
      <book-nav></book-nav>

      <div v-if="child_books && child_books.length > 0 && (!$route.query.page || $route.query.page < 2)">
        <div
            :key="book.id"
            class="flex bg-white font-bold border border-blue-700 cursor-pointer mb-3"
            v-for="book in child_books"
        >
          <div class="text-center w-full">
            <router-link
                :data-cy="
                    `book-link-${book.type}${book.encrypt ? '-enc' : ''}`
                  "
                :to="'/admin/notes?book=' + book.id"
                class="text-lg py-4 px-2 block"
            >
              {{ book.title }}
            </router-link>
          </div>
          <div class="text-center border-l">
            <div
                class="text-lg py-4 px-6 block"
                v-on:click="(e) => createNote(e, book.id)"
            >
              +
            </div>
          </div>
        </div>
      </div>
      <div v-if="notes && notes.length > 0">
        <div>
          <div v-for="(note, msgIndex) in notes">
            <admin-notes-card-edit
              :note-id="note.id"
              v-if="note.editing"
            >
            </admin-notes-card-edit>

            <note-card
                :id="['note' + note.id]"
                :key="note.id"
                :msgIndex="msgIndex"
                :note="note"
                class="note"
                v-else
            >
            </note-card>
          </div>
        </div>
        <!-- col-md-8 -->

        <div class="col-md-4">
          <div
            class="btn btn-primary"
            v-if="book && book.settings && book.settings.allowLeaving"
            v-on:click="leaveGroup"
          >
            Leave Group
          </div>
        </div>

        <paginate
          :currentPage="admin_book_search.page"
          class="mb-5"
          v-on:paginate="paginate"
        >
        </paginate>
      </div>

      <div class="mb-5" v-else-if="book">
        <p class="mb-3 text-2xl">0 Notes</p>
        <!--          <router-link class="button-1 inline-block" :to="{path: '/admin/notes/create', query: { book: book.id }}">create a note</router-link>-->
      </div>
    </div>
  </div>
</template>

<script>
import "vue-date-pick/dist/vueDatePick.css";
import { API_URL } from "../../env.js";
import Loading from "../ui/Loading.vue";
import DatePicker from "vuejs-datepicker";
import datetime from "vuejs-datetimepicker";
import Navigation from "../Navigation.vue";
import NoteCard from "./NoteCard.vue";
import Modal from "../ui/Modal.vue";
import DREditor from "../DoxEditor.vue";
import qs from "query-string";
import AdminNotesResource from "./AdminNotesResource.vue";
import Paginate from "../Paginate.vue";
import BookNav from "./BookNav.vue";
import AdminNotesCardEdit from "./AdminNotesCardEdit";
var smoothscroll = require("smoothscroll");

export default {
  created: function() {
    let search = this.getSearch(this.$route);

    // const shouldGetNotes = !this.notes || (this.notes && this.notes.length === 0) || !this.book || (parseInt(this.$route.query.book) !== this.book.id);
    // Compare the notesFetchKey with the query parameters string. If they are not
    // equal, then get the notes.
    const queryString = qs.stringify(this.$route.query);
    const shouldGetNotes = queryString !== this.notesFetchKey;
    if (shouldGetNotes) {
      console.log("getting notes");
      const uri = `${API_URL}/admin/notes?${queryString}`;
      this.$store.dispatch("aGetNotesAdmin", {
        uri,
        search,
        notesFetchKey: queryString
      });
    }
  },

  components: {
    Loading,
    Navigation,
    NoteCard,
    datetime,
    Modal,
    DatePicker,
    dreditor: DREditor,
    AdminNotesResource,
    Paginate,
    BookNav,
    AdminNotesCardEdit
  },

  methods: {
    async createNote(e, book_id) {
      const noteId = await this.$store.dispatch("aCreateNote", book_id);
      this.$router.push({ path: `/admin/notes/${noteId}/update` });
    },
    author() {
      return this.$store.state.notes.author;
    },
    getSearch(to) {
      let search = {};
      search.query = to.query.query;
      search.book = this.$route.query.book || null;
      let category = this.admin_book_terms.filter(term => {
        return term.slug === to.query.category;
      });
      search.category = category[0];
      search.page = to.query.page;
      return search;
    },
    clearCategory: function(term) {
      let search = Object.assign({}, this.$route.query);
      delete search["page"];
      delete search["category"];
      this.$router.push({ path: this.$route.path, query: search });
    },
    paginate(direction) {
      let search = Object.assign({}, this.$route.query);
      const currentPage = search.page ? parseInt(search.page) : 1;
      search.page = direction === "next" ? currentPage + 1 : currentPage - 1;
      if (search.page < 1) {
        return;
      }
      this.$router.push({ path: this.$route.path, query: search });
      var destToScroll = document.getElementById("title");
      smoothscroll(destToScroll);
    },
  },
  computed: {
    notesFetchKey() {
      return this.$store.state.notes.notesFetchKey;
    },
    user: function() {
      return this.$store.state.notes.user;
    },
    notes: function() {
      return this.$store.state.notes.notes;
    },
    book: function() {
      return this.$store.state.notes.book;
    },
    book_error: function() {
      return this.$store.state.notes.book_error;
    },
    terms() {
      return this.$store.state.notes.terms;
    },
    selected_term() {
      return this.$store.state.notes.selected_term;
    },
    admin_book_search() {
      return this.$store.state.notes.admin_book_search;
    },
    admin_book_terms() {
      return this.$store.state.notes.admin_book_terms;
    },
    child_books() {
      console.log('child books', this.$store.state.notes.child_books, this.$route.query.page < 2, this.$route.query.page)
        return this.$store.state.notes.child_books;
    },
  },
  watch: {
    $route(to, from) {
      let search = this.getSearch(to);
      const uri = `${API_URL}${to.fullPath}`;
      console.log('getting', search, uri);
      this.$store.dispatch("aGetNotesAdmin", { uri, search });
    },
    book_error(newGroupError, oldGroupError) {
      if (newGroupError === "logged_out") {
        alert("Please login or register to enter this book.");
        this.$store.dispatch("TOGGLE_LOGIN_POPUP");
      }

      if (newGroupError === "invitation_accepted") {
        alert(
          "Welcome! Your invitation has been automatically accepted, and you can, now, enter this book."
        );
      }

      if (newGroupError === "not_authorized") {
        alert("You are not a part of this book. Try creating a new book.");
        this.$router.push({ path: "/home" });
      }

      // If the book_error was changed (the user logs in),
      // try fetching the notes, again
      // The book_error will change to either invitation_accepted or not_authorized
      if (newGroupError === false) {
        this.$store.dispatch("ADMIN_BOOKS_BOOK", {
          id: this.$route.params.id,
          router: this.$router
        });
      }
    }
  }
};
</script>
